/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'pwdW1rFYBYYYdNfTsTL9sT.png': { uri: '/images/pwdW1rFYBYYYdNfTsTL9sT.png' },
'mLQB8bZTgR5uKwWz3ridJU.png': { uri: '/images/mLQB8bZTgR5uKwWz3ridJU.png' },
'k3avfvix4Qu5Ykt4TSGVhz.png': { uri: '/images/k3avfvix4Qu5Ykt4TSGVhz.png' },
'wRxPVuK2baqrxBhJaxQByW.png': { uri: '/images/wRxPVuK2baqrxBhJaxQByW.png' },
'jzV1WJW7tF3bpmGh6kiMcA.png': { uri: '/images/jzV1WJW7tF3bpmGh6kiMcA.png' },
'9S2UmnMoaTREnRX7NkTUCZ.png': { uri: '/images/9S2UmnMoaTREnRX7NkTUCZ.png' },
'6qW2SDdLTjgzyPUSX9mbw6.png': { uri: '/images/6qW2SDdLTjgzyPUSX9mbw6.png' },
'n2bgwjM2M7rA59Zc24FZjz.png': { uri: '/images/n2bgwjM2M7rA59Zc24FZjz.png' },
'o8f8ogvV75wAeKQdWEC9Ea.png': { uri: '/images/o8f8ogvV75wAeKQdWEC9Ea.png' },
'eotJ9bHbQiS2cNWQEHmLoC.png': { uri: '/images/eotJ9bHbQiS2cNWQEHmLoC.png' },
'svERYkok4hyJZD8ySeyJJp.png': { uri: '/images/svERYkok4hyJZD8ySeyJJp.png' },
'knWF5pYBEnhe4ro1Vduj6j.png': { uri: '/images/knWF5pYBEnhe4ro1Vduj6j.png' },
'uUGvKs4Tae91WeXqorpfj8.png': { uri: '/images/uUGvKs4Tae91WeXqorpfj8.png' },
'ppi9XwhisgtBqWtGbf2CjW.png': { uri: '/images/ppi9XwhisgtBqWtGbf2CjW.png' },
'cJgX5uDsLwckozVGeXGuoQ.png': { uri: '/images/cJgX5uDsLwckozVGeXGuoQ.png' },
'ad2FLk6t238MhT13WmumxE.png': { uri: '/images/ad2FLk6t238MhT13WmumxE.png' },
'2TsBYwnDXoKJM5ZYvWPLiN.png': { uri: '/images/2TsBYwnDXoKJM5ZYvWPLiN.png' },
'aBhnxGNzUu2MDJBLpj7HCv.webp': { uri: '/images/aBhnxGNzUu2MDJBLpj7HCv.webp' },
'3oAqKgJS5topWheQzYH35V.png': { uri: '/images/3oAqKgJS5topWheQzYH35V.png' },
'26ym1CC6F8RUoyPJcUqsnL.png': { uri: '/images/26ym1CC6F8RUoyPJcUqsnL.png' },
'fEsur1igNzrNRZoNToZr9F.png': { uri: '/images/fEsur1igNzrNRZoNToZr9F.png' },
'tyuGdBFZjUsmMx4yVjXXZ8.png': { uri: '/images/tyuGdBFZjUsmMx4yVjXXZ8.png' },
'q8cquQVGpgVQ7wfK7xYMwG.png': { uri: '/images/q8cquQVGpgVQ7wfK7xYMwG.png' },
'uBFuwqPQ5x6DMrhCPxoSd2.png': { uri: '/images/uBFuwqPQ5x6DMrhCPxoSd2.png' },
'i4PNNsq7Kgqsu4GAhTgtAm.png': { uri: '/images/i4PNNsq7Kgqsu4GAhTgtAm.png' },
'pn8iBTScdF2LGMLxHZKCVu.png': { uri: '/images/pn8iBTScdF2LGMLxHZKCVu.png' },
'uWmuJmii9nAHWMyxG1iS52.png': { uri: '/images/uWmuJmii9nAHWMyxG1iS52.png' },
'mmVhf9nTMMGnWEC7xcmCos.png': { uri: '/images/mmVhf9nTMMGnWEC7xcmCos.png' },
'xvVt8yGE4hFkpZsJy7jhSq.png': { uri: '/images/xvVt8yGE4hFkpZsJy7jhSq.png' },
'mi9q9dKfW8128SuHTVVDa3.png': { uri: '/images/mi9q9dKfW8128SuHTVVDa3.png' },
'gy3MNX1ePcQ3bzfYYDxC4E.png': { uri: '/images/gy3MNX1ePcQ3bzfYYDxC4E.png' },
'vfYCVRBUnggfuBvmurLkja.png': { uri: '/images/vfYCVRBUnggfuBvmurLkja.png' },
'9cxJQFHKGep7XVSLuQwMyB.png': { uri: '/images/9cxJQFHKGep7XVSLuQwMyB.png' },
'87W8dhqfZXEghF4K7poYLj.png': { uri: '/images/87W8dhqfZXEghF4K7poYLj.png' },
'csRtCETAZCt4JMrYfBXdbe.png': { uri: '/images/csRtCETAZCt4JMrYfBXdbe.png' },
'iboCWmkQAAXMqFk3SjrEAk.png': { uri: '/images/iboCWmkQAAXMqFk3SjrEAk.png' },
'cRC1JfVeAdzy5GGk8hzGp9.png': { uri: '/images/cRC1JfVeAdzy5GGk8hzGp9.png' },
'uYq6Bz6duLckHkbSU2biBF.png': { uri: '/images/uYq6Bz6duLckHkbSU2biBF.png' },
'biHmTw5mYXmPATTVrrrdCF.png': { uri: '/images/biHmTw5mYXmPATTVrrrdCF.png' }
}

export default imageStaticSourcesByFileName
